import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import { cropUpdateInfo } from "../../../SchemaInfo/info";
import { cropUpdateInfoSchema } from "../../../Schemas/Crop Update/crop_update_create";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import Footer from "../../../Components/Footer/footer";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { PiPottedPlantDuotone } from "react-icons/pi";
import { uploadImage } from "../../../CustomComponent/upload_Image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import CustomTextArea from "../../../CustomComponent/custom_textarea";

const EditCropUpdate = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [plantList, setPlantList] = useState([]);
  const [arrayLength, setArrayLength] = useState();
  const [croppdateInfo, setCropUpdateInfo] = useState(cropUpdateInfo);
  const [imageInfo, setImageInfo] = useState({
    name: "",
    url: "",
  });
  let { id } = useParams();
  const navigate = useNavigate();
  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: userData?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/projectTracking/getProjectTracking", 1)
    )
      .then((res) => {
        if (res.status === 200) {
          let access = {
            isHandOverCompleted: false,
            workOrder: false,
            isClient: false,
          };

          if (res?.data?.clientHandover?.handOverCertificate) {
            access.isHandOverCompleted = true;
          }
          if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
            access.workOrder = true;
          }
          if (userData?.Role == process.env.REACT_APP_ROLE_CLIENT) {
            access.isClient = true;
          }
          setCheckClientAccess(access);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = (values, actions) => {
    setLoading(true);

    const formData = new FormData();

    // Preserve existing image URLs if not replaced
    const cropPhotoMetadata = values.cropPhoto.map(
      ({ cropUploadPhoto, ...rest }) => {
        return {
          ...rest,
          ...(typeof cropUploadPhoto === "string" && cropUploadPhoto !== ""
            ? { cropUploadPhoto }
            : {}),
        };
      }
    );

    formData.append("cropPhoto", JSON.stringify(cropPhotoMetadata));

    Object.entries(values).forEach(([key, value]) => {
      if (key !== "cropPhoto") {
        formData.append(key, value);
      }
    });
    let count = 0;
    values.cropPhoto.forEach((item, index) => {
      if (item.scheduleDone) count++;
      if (item.cropUploadPhoto instanceof File) {
        formData.append(`cropUploadPhoto-${index}`, item.cropUploadPhoto);
      }
    });

    if (
      checkClientAccess.isClient &&
      !checkClientAccess.isHandOverCompleted &&
      count > 10
    ) {
      Toast(
        "error",
        "Your handover process is not yet complete, so you cannot update the details at this time. Please contact the Kryzen support team for further assistance."
      );
      setLoading(false);
    } else {
      performRequest("PATCH", `/cropUpdate/updatecropUpdate/${id}`, formData)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Crop update created successfully!");
            navigate(`/farm-crop-schedule`);
          } else {
            Toast("error", "Error while creating water cycle");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res?.data?.data || []);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cropUpdate/getCropUpdateById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setCropUpdateInfo(res.data);
          setArrayLength(res.data.cropPhoto.length);
        } else {
          Toast("error", "Error while getting updates!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  // const generateDateLabels = (startdate, systemType) => {
  //   const schedule = [];
  //   if (systemType === "growBags") {
  //     for (let i = 0; i < growbagSchedule.length; i++) {
  //       const date = new Date(startdate);
  //       date.setDate(date.getDate() + i);

  //       schedule.push({
  //         date: date.toISOString().split("T")[0],
  //         ...growbagSchedule[i],
  //         cropUploadPhoto: "",
  //         scheduleDone: false,
  //         scheduleDoneDate: "",
  //       });
  //     }
  //   } else if (systemType === "nft-single-cycle") {
  //     for (let i = 0; i < nftSingleCycle.length; i++) {
  //       const date = new Date(startdate);
  //       date.setDate(date.getDate() + i);

  //       schedule.push({
  //         date: date.toISOString().split("T")[0],
  //         ...nftSingleCycle[i],
  //         cropUploadPhoto: "",
  //         scheduleDone: false,
  //         scheduleDoneDate: "",
  //       });
  //     }
  //   } else if (systemType === "nft-herbs") {
  //     for (let i = 0; i < nftHerbs.length; i++) {
  //       const date = new Date(startdate);
  //       date.setDate(date.getDate() + i);

  //       schedule.push({
  //         date: date.toISOString().split("T")[0],
  //         ...nftHerbs[i],
  //         cropUploadPhoto: "",
  //         scheduleDone: false,
  //         scheduleDoneDate: "",
  //       });
  //     }
  //   }

  //   return schedule;
  // };
  const getBG = (date) => {
    let newDt = new Date().toISOString().split("T")[0];

    if (date == newDt) {
      return "bg-primary-lt";
    }
    return "";
  };
  if (loading) {
    return <LoadingPage />;
  }
  const getScheduleBadge = (schedule) => {
    if (schedule === "Fertigation") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-yellow text-white m-1">Fertigation</span>{" "}
        </p>
      );
    }
    if (schedule === "Spray") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-green text-white m-1">Spray</span>
        </p>
      );
    }
    if (schedule === "Drenching") {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-azure text-white m-1">Drenching</span>
        </p>
      );
    }
    if (schedule) {
      return (
        <p className="m-0 p-0">
          <span className="badge bg-danger text-white m-1">{schedule}</span>
        </p>
      );
    } else {
      return schedule;
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <PiPottedPlantDuotone
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Crop Schedule
                </h2>
                <h4 className="text-muted">Track & manage your crops.</h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/farm-crop-schedule/"} className="btn btn-primary">
                    <PiPottedPlantDuotone className="fs-3 me-2" />
                    ALL UPDATES
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row col-12">
            <div className="card">
              <Formik
                initialValues={croppdateInfo}
                validationSchema={cropUpdateInfoSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Crop name
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="cropName"
                            disabled={props.values?.cropPhoto?.length > 0}
                          >
                            <option value="">Select</option>
                            {plantList.map((plant) => (
                              <option key={plant.id} value={plant.name}>
                                {plant.name}
                              </option>
                            ))}
                          </CustomSelect>
                          {props.touched.cropName && props.errors.cropName && (
                            <p className="text-danger">
                              {props.errors.cropName}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Crop cycle name
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="cropCycleName" type="text" />
                          {props.touched.cropCycleName &&
                            props.errors.cropCycleName && (
                              <p className="text-danger">
                                {props.errors.cropCycleName}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Type of system
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            type="text"
                            name="typeOfSystem"
                            disabled={props.values?.cropPhoto?.length > 0}
                          >
                            <option value="">Select</option>
                            {/* <option value="a-frame">A-Frame</option>
                            <option value="flatBed">Flatbed</option> */}
                            <option value="growBags">Grow Bags</option>
                            <option value="nft-single-cycle">
                              NFT-Single Cycle
                            </option>
                            <option value="nft-herbs">NFT-Herbs</option>
                            {/* <option value="indoorHydroponic">
                              Indoor Hydroponic
                            </option> */}
                          </CustomSelect>
                          {props.touched.typeOfSystem &&
                            props.errors.typeOfSystem && (
                              <p className="text-danger">
                                {props.errors.typeOfSystem}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          CEA system
                        </label>
                        <div className="w-100 col">
                          <CustomSelect type="text" name="ceaSystem">
                            <option value="">Select</option>
                            <option value="nvph">NVPH</option>
                            <option value="fanpad">Fanpad</option>
                            <option value="indoor">Indoor</option>
                            <option value="open cultivation">
                              Open Cultivation
                            </option>
                          </CustomSelect>
                          {props.touched.ceaSystem &&
                            props.errors.ceaSystem && (
                              <p className="text-danger">
                                {props.errors.ceaSystem}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Water tank capacity
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="waterTankCapacity" type="text" />
                          {props.touched.waterTankCapacity &&
                            props.errors.waterTankCapacity && (
                              <p className="text-danger">
                                {props.errors.waterTankCapacity}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Crop cycle start date
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="cropCycleStartDate"
                            type="date"
                            disabled={props.values?.cropPhoto?.length > 0}
                          />
                          {props.touched.cropCycleStartDate &&
                            props.errors.cropCycleStartDate && (
                              <p className="text-danger">
                                {props.errors.cropCycleStartDate}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Total crop count
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="totalCropCount" type="text" />
                          {props.touched.totalCropCount &&
                            props.errors.totalCropCount && (
                              <p className="text-danger">
                                {props.errors.totalCropCount}
                              </p>
                            )}
                        </div>
                      </div>

                      <FieldArray name="cropPhoto">
                        {({ push, remove }) => (
                          <div className="card">
                            {/* Header */}
                            <div className="card-header">
                              <div>
                                <h3 className="card-title mb-1">
                                  Crop Schedule
                                </h3>
                                <div className="text-secondary">
                                  Track daily activities, photos and work
                                  completion.
                                </div>
                              </div>

                              <div className="card-actions">
                                <span className="badge bg-blue-lt">
                                  {props.values?.cropPhoto?.length || 0} Days
                                </span>
                              </div>
                            </div>

                            {/* Table */}
                            {props.values?.cropPhoto?.length > 0 && (
                              <div className="table-responsive">
                                <table className="table table-vcenter table-hover mb-0">
                                  <thead>
                                    <tr>
                                      <th>Day</th>

                                      <th>
                                        Date /{" "}
                                        {props.values?.typeOfSystem ===
                                        "growBags"
                                          ? "Activity"
                                          : "Tank Maintenance"}
                                      </th>

                                      <th>pH / EC</th>

                                      <th>Operations</th>

                                      <th>Crop Photo</th>

                                      <th>Note</th>

                                      <th>Work Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {props.values?.cropPhoto?.map(
                                      (schedule, index) => {
                                        const activity =
                                          props.values?.typeOfSystem ===
                                          "growBags"
                                            ? schedule.Activity
                                            : schedule.tankMaintenance;

                                        const operation =
                                          props.values?.typeOfSystem ===
                                          "growBags"
                                            ? schedule.Composition
                                            : schedule.spraySchedule;

                                        return (
                                          <tr
                                            key={index}
                                            className={getBG(schedule.date)}
                                          >
                                            {/* DAY */}
                                            <td>
                                              <span className="badge bg-blue-lt">
                                                Day {schedule.Day}
                                              </span>
                                            </td>

                                            {/* DATE / ACTIVITY */}
                                            <td>
                                              <div className="fw-bold">
                                                {schedule.date}
                                              </div>

                                              <div className="mt-1">
                                                {getScheduleBadge(activity)}
                                              </div>
                                            </td>

                                            {/* PH / EC */}
                                            <td>
                                              <div className="d-flex flex-column gap-1">
                                                <span className="badge bg-azure-lt">
                                                  pH&nbsp; {schedule.pH || "-"}
                                                </span>

                                                <span className="badge bg-purple-lt">
                                                  EC&nbsp; {schedule.EC || "-"}
                                                </span>
                                              </div>
                                            </td>

                                            {/* OPERATIONS */}
                                            <td>
                                              <div className="fw-semibold">
                                                {schedule.Timer || "-"}
                                              </div>

                                              {operation && (
                                                <div className="text-orange mt-1">
                                                  {operation}
                                                </div>
                                              )}
                                            </td>

                                            {/* CROP PHOTO */}
                                            <td>
                                              <div className="d-flex flex-column gap-2">
                                                {schedule?.cropUploadPhoto && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modal-scrollable"
                                                    onClick={() =>
                                                      setImageInfo({
                                                        url: schedule.cropUploadPhoto,
                                                      })
                                                    }
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      className="icon"
                                                      width="24"
                                                      height="24"
                                                      viewBox="0 0 24 24"
                                                      strokeWidth="2"
                                                      stroke="currentColor"
                                                      fill="none"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M15 8h.01" />
                                                      <path d="M4 7v-1a2 2 0 0 1 2-2h1" />
                                                      <path d="M4 17v1a2 2 0 0 0 2 2h1" />
                                                      <path d="M17 4h1a2 2 0 0 1 2 2v1" />
                                                      <path d="M17 20h1a2 2 0 0 0 2-2v-1" />
                                                      <path d="M7 12l3 3 7-7" />
                                                    </svg>
                                                    View Uploaded Photo
                                                  </button>
                                                )}

                                                <CustomInput
                                                  name={`cropPhoto[${index}].cropUploadPhoto`}
                                                  type="file"
                                                  onChange={(e) =>
                                                    props.setFieldValue(
                                                      `cropPhoto[${index}].cropUploadPhoto`,
                                                      e.target.files?.[0] || ""
                                                    )
                                                  }
                                                />

                                                {props.touched.cropPhoto?.[
                                                  index
                                                ]?.cropUploadPhoto &&
                                                  props.errors.cropPhoto?.[
                                                    index
                                                  ]?.cropUploadPhoto && (
                                                    <div className="text-danger small">
                                                      {
                                                        props.errors.cropPhoto[
                                                          index
                                                        ].cropUploadPhoto
                                                      }
                                                    </div>
                                                  )}
                                              </div>
                                            </td>

                                            {/* NOTE */}
                                            <td className="w-25">
                                              <CustomTextArea
                                                name={`cropPhoto[${index}].note`}
                                                placeholder="Add note..."
                                                onChange={(e) =>
                                                  props.setFieldValue(
                                                    `cropPhoto[${index}].note`,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </td>
                                            {/* WORK STATUS */}
                                            <td>
                                              <CustomCheckbox
                                                type="checkbox"
                                                width={"23px"}
                                                height={"23px"}
                                                name={`cropPhoto[${index}].scheduleDone`}
                                                onChange={() => {
                                                  const isDone =
                                                    !schedule.scheduleDone;

                                                  props.setFieldValue(
                                                    `cropPhoto[${index}].scheduleDone`,
                                                    isDone
                                                  );

                                                  props.setFieldValue(
                                                    `cropPhoto[${index}].scheduleDoneDate`,
                                                    isDone
                                                      ? new Date()
                                                          .toISOString()
                                                          .split("T")[0]
                                                      : ""
                                                  );
                                                }}
                                              />
                                              <span className="form-check-label">
                                                {schedule.scheduleDone ? (
                                                  <span className="text-success fw-semibold">
                                                    Completed
                                                  </span>
                                                ) : (
                                                  <span className="text-warning fw-semibold">
                                                    Pending
                                                  </span>
                                                )}
                                              </span>

                                              {schedule.scheduleDoneDate && (
                                                <span className="text-secondary small">
                                                  {schedule.scheduleDoneDate}
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}

                            {/* Empty State */}
                            {!props.values?.cropPhoto?.length && (
                              <div className="empty py-5">
                                <div className="empty-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-lg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <path d="M4 7v-1a2 2 0 0 1 2-2h1" />
                                    <path d="M4 17v1a2 2 0 0 0 2 2h1" />
                                    <path d="M17 4h1a2 2 0 0 1 2 2v1" />
                                    <path d="M17 20h1a2 2 0 0 0 2-2v-1" />
                                    <path d="M7 12l3 3 7-7" />
                                  </svg>
                                </div>

                                <p className="empty-title">No Crop Schedule</p>

                                <p className="empty-subtitle text-secondary">
                                  Generate a crop schedule to start managing
                                  daily activities.
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Update crop schedule" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-scrollable"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{imageInfo.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-4">
                <LazyImageComponent
                  width={700}
                  src={imageInfo.url}
                  alt="not uploaded"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditCropUpdate;
